import React from 'react';
import Layout from '@/Shared/Layout';
import {InertiaLink, usePage} from '@inertiajs/inertia-react';
import PaginateCount from '@/Shared/PaginateCount';
import StaticPagesSearchFilter from '@/Pages/MetaInfo/Assets/StaticPagesSearchFilter';
import TableHeadSort from '@/Shared/TableHeadSort';
import Pagination from '@/Shared/Pagination';
import StaticPagesActionBtns from "@/Pages/MetaInfo/Assets/StaticPagesActionBtns";

const Index = () => {
  const {static_pages} = usePage().props;

  const {
    data,
    links
  } = static_pages;

  return (
    <div>
      <div className='mb-3 flex justify-between items-center'>
        <h1 className='text-3xl font-bold'>Static Pages</h1>
        <InertiaLink
          className='btn-default focus:outline-none'
          href={route('static-page.create')}
        >
          <span>Create</span>
          <span className='hidden md:inline'> Meta Info</span>
        </InertiaLink>
      </div>

      <div className='flex items-center justify-between mb-6'>
        <StaticPagesSearchFilter/>

        <PaginateCount/>
      </div>

      <div className='overflow-x-auto bg-white rounded shadow'>
        <table className='w-full table-auto text-sm'>
          <thead>
          <tr className='font-bold text-left'>
            <th className='px-1 pt-5 pb-4 w-1'>_</th>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-1' sortName='static_page_id' title='ID'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='title' title='Title'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='url' title='URL'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='description' title='Description'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='keywords' title='Keywords'/>

            <th className='px-1 pt-5 pb-4'>Actions</th>
          </tr>
          </thead>
          <tbody>
          {data.map(({
                       static_page_id,
                       title,
                       url,
                       description,
                       keywords,
                       absolute_url,
                       def_image_logo,
                     }) => (
            <tr
              key={static_page_id}
              className='hover:bg-gray-100 focus-within:bg-gray-100'
            >
              <td className='border-t'>
                <InertiaLink
                  href={route('static-page.edit', static_page_id)}
                  className='flex items-center px-1 py-4 focus:text-indigo-700 focus:outline-none'
                >
                  >
                </InertiaLink>
              </td>
              <td className='border-t'>
                <InertiaLink
                  tabIndex='1'
                  className='flex items-center px-1 py-4 focus:text-indigo focus:outline-none'
                  href={route('static-page.edit', static_page_id)}
                >
                  {static_page_id}
                </InertiaLink>
              </td>
              <td className='border-t'>
                <InertiaLink
                  tabIndex='1'
                  className='flex items-center px-1 py-4 focus:text-indigo focus:outline-none'
                  href={route('static-page.edit', static_page_id)}
                >
                  {title}
                </InertiaLink>
              </td>
              <td className='border-t'>
                <InertiaLink
                  tabIndex='1'
                  className='flex items-center px-1 py-4 focus:text-indigo focus:outline-none'
                  href={route('static-page.edit', static_page_id)}
                >
                  {url}
                </InertiaLink>
              </td>
              <td className='border-t'>
                <InertiaLink
                  tabIndex='1'
                  className='flex items-center px-1 py-4 focus:text-indigo focus:outline-none'
                  href={route('static-page.edit', static_page_id)}
                >
                  {description}
                </InertiaLink>
              </td>
              <td className='w-px border-t'>
                <InertiaLink
                  tabIndex='-1'
                  href={route('static-page.edit', static_page_id)}
                  className='flex items-center px-1 focus:outline-none'
                >
                  {keywords}
                </InertiaLink>
              </td>

              <td className='w-px border-t'>
                <StaticPagesActionBtns absolute_url={absolute_url} def_image_logo={def_image_logo}/>
              </td>
            </tr>
          ))}
          {data.length === 0 && (
            <tr>
              <td className='px-1 py-4 border-t' colSpan='4'>
                No coupons found.
              </td>
            </tr>
          )}
          </tbody>
        </table>

      </div>
      <div className='py-2 text-xs text-slate-400'>
        Note: Sections that have pagination are marked with "/*". For example, a blog section can have many pages, so
        the address can be "www.couponola.com/blog/1, www.couponola.com/blog/2, www.couponola.com/blog/3: "blog/1",
        "blog/2", "blog/3". To display meta information on all of
        them it should be written with this url: "blog/*".
      </div>
      <Pagination links={links}/>
    </div>
  );
};

Index.layout = page => <Layout title='Static Pages' children={page}/>;

export default Index;
